import { DIR_DOCUMENT } from '@angular/cdk/bidi';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, Inject, Injector, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtModule } from '@auth0/angular-jwt';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LoadingComponent } from '../shared/component/loading/loading.component';
import { ApplicationInitializerFactory, JWT_Module_Options, translationLoaderConfig } from '../shared/helper';
import { LocaleIdHandler } from '../shared/helper/locale-id-handler';
import { SharedModule } from '../shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './component/app.component';
import { TokenInterceptor } from '../core/helper/token.interceptor';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ApplicationThemeFactory } from '../core/services/themes.service';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { AngularFireModule } from '@angular/fire/compat';
import { environment } from 'src/environments/environment';
import { PushNotificationService } from '../core/services/push-notification.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    JwtModule.forRoot(JWT_Module_Options),
    TranslateModule.forRoot(translationLoaderConfig),
    AngularSvgIconModule.forRoot(),
    SimpleNotificationsModule.forRoot(),
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),
    LoadingComponent,
    SharedModule,
  ],
  providers: [
    PushNotificationService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    { provide: DIR_DOCUMENT, useValue: 'ltr' },
    { provide: LOCALE_ID, useClass: LocaleIdHandler, deps: [TranslateService] },
    {
      provide: APP_INITIALIZER,
      useFactory: ApplicationInitializerFactory,
      deps: [Injector],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: ApplicationThemeFactory,
      deps: [Injector],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
